import React, { createContext, useContext, useState, useEffect } from 'react';

const MENU_LAYOUT_KEY = 'menuLayout';
const LAYOUTS = ['sidebar', 'taskbar'];

const MenuLayoutContext = createContext({
  menuLayout: 'sidebar',
  setMenuLayout: () => {},
  cycleMenuLayout: () => {},
  sidebarWidth: 260,
});

export function MenuLayoutProvider({ children }) {
  const [menuLayout, setMenuLayoutState] = useState(() => {
    try {
      const saved = localStorage.getItem(MENU_LAYOUT_KEY);
      return LAYOUTS.includes(saved) ? saved : 'sidebar';
    } catch {
      return 'sidebar';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(MENU_LAYOUT_KEY, menuLayout);
    } catch (e) {
      console.warn('MenuLayout persist failed', e);
    }
  }, [menuLayout]);

  const setMenuLayout = (next) => {
    if (LAYOUTS.includes(next)) setMenuLayoutState(next);
  };

  const cycleMenuLayout = () => {
    setMenuLayoutState((prev) => {
      const i = LAYOUTS.indexOf(prev);
      return LAYOUTS[(i + 1) % LAYOUTS.length];
    });
  };

  const sidebarWidth = menuLayout === 'sidebar' ? 260 : 0;

  return (
    <MenuLayoutContext.Provider
      value={{ menuLayout, setMenuLayout, cycleMenuLayout, sidebarWidth }}
    >
      {children}
    </MenuLayoutContext.Provider>
  );
}

export function useMenuLayout() {
  const ctx = useContext(MenuLayoutContext);
  if (!ctx) {
    return {
      menuLayout: 'sidebar',
      setMenuLayout: () => {},
      cycleMenuLayout: () => {},
      sidebarWidth: 260,
    };
  }
  return ctx;
}
